import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createRequisition(data) {
    let response = await apiCall("requisitions/create", data);
    return response;
  },
  async fetchRequisitionsList(data) {
    let response = await apiCall("list/requisitions", data);
    return response;
  },
  async updateRequisition(data) {
    let response = await apiCall("requisitions/update_requisition", data);
    return response;
  },
  async fetchRecentRequisitions(data) {
    let response = await apiCall("list/requisitions/fetch_recent_10", data);
    return response;
  },
  async fetchRequisitionsTosetApprovelslevel(data) {
    let response = await apiCall(
      "list/requisitions/to_set_approval_levels",
      data
    );
    return response;
  },
  async fetchRequisitionsListWith_rejected_items(data) {
    let response = await apiCall(
      "list/list_requisitions_with_rejected_items",
      data
    );
    return response;
  },
  async allowRejectedItems(data) {
    let response = await apiCall("list/allow_rejected_items", data);
    return response;
  },
  async fetchRequisitions_ready_to_order(data) {
    let response = await apiCall("list/requisitions_mini_data", data);
    return response;
  },
  async fetchRequisitionItems(data) {
    let response = await apiCall("requisitions/get_requisition_items", data);
    return response;
  },
  async updateApprovalLevel(data) {
    let response = await apiCall(
      "requisitions/update_approval_level_requisition",
      data
    );
    return response;
  },
  async setReadyToOrder(data) {
    let response = await apiCall("requisitions/set_ready_to_order", data);
    return response;
  },
  async ReadyToOrderRequisitionsView(data) {
    let response = await apiCall(
      "requisitions/list_requisition_ready_to_order",
      data
    );
    return response;
  },
};
